import React, { useState, useEffect, useContext,useCallback } from "react";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ProfileCard from "../../Component/ProfileCard";
import SettingsCard from "../../Component/SettingCard";
import { Container, Box, Card, Avatar, Typography, Tabs, Tab, Drawer, IconButton, Button, Menu, MenuItem } from "@mui/material";
import DriveWithUsState from "../../Hooks/DriveWithUs.state";
import Header from "Layout/Header";
import { WhatsApp } from "@mui/icons-material";
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import Close from '@mui/icons-material/Close';
import { IMAGES_URL } from "Utils/URLs";
import { getDisplayUrl } from "Utils/mediaUrl";
import CustomTabs from "Component/CustomeTabs";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import PaymentsIcon from "@mui/icons-material/Payments";
import CarRepairIcon from "@mui/icons-material/CarRepair";
import { useNavigate } from "react-router-dom";
import { UserContext } from "Hooks/UserContext";
import CustomButton from "Component/CustomButton";
import PersonIcon from '@mui/icons-material/Person';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PartnerWithUsState from "../../Hooks/PartnerWithUs.state";
import FreeRideState from "../../Hooks/FreeRide.state";
const theme = createTheme();


export default function Profile() {
  const [text, setText] = useState("");
  const [openLink, setOpenLink] = useState(false)
  const { GetDriveWithUs, loading, driveWithUsData } = DriveWithUsState()
  const { GetFreeRide,freeRideData } = FreeRideState()
  const { GetPartnerWithUs,partnerWithUsData } = PartnerWithUsState()
  const [anchorElNav, setAnchorElNav] = React.useState(false);
  const navigate = useNavigate()
  const { user, value, setValue } = useContext(UserContext)
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

const getData = async () => {
    try {
      console.log("render====>");
      if (user?.form_name === "drive_with_us") {
        await GetDriveWithUs();
      } else if (user?.form_name === "partner_with_us") {
        await GetPartnerWithUs();
      } else if (user?.form_name === "free_ride") {
        await GetFreeRide();
      }
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    getData()
  }, [user])

  const mainUser = {

    title: "CEO of Apple",
    dt1: 32,
    dt2: 40,
    dt3: 50,
    firstName: { text },
    lastName: "Doe",
    midName: "Baker",
    gender: "female",
    phone: "932-555-4247",
    email: "janedoe@gmail.com",
    pass: "password123"
  };

  const fullName = `${mainUser.firstName} ${mainUser.lastName}`;
  const Label = (form_name) => {
    switch (form_name) {
      case "drive_with_us":
        return "Drive With Us"
      case "free_ride":
        return "Free Ride"
      case "partner_with_us":
        return "Partner With Us"

      default:
        break;
    }
  }

  function isExpired(dateString) {
    const givenDate = new Date(dateString);
    const currentDate = new Date();

    return givenDate < currentDate;
  }

  const expiredFiles = driveWithUsData.filter(
    (item) => isExpired(item.file_expiry) || item.file_status === 2
  );

  const expiredCount = expiredFiles.length;

  const isDriveTabVisible =
    user?.form_name === "drive_with_us" && expiredCount > 0;
  const mobileTabs = [
    {
      value: 1,
      label: "Profile",
      icon: <i className="las la-user" />,
      condition: true,
    },
    {
      value: 3,
      label: "Drive With Us",
      icon: <i className="las la-car" />,
      condition:
        user?.form_name === "drive_with_us" &&
        driveWithUsData.some(
          (item) => isExpired(item.file_expiry) || item.file_status === 2
        ),
    },
    {
      value: 3,
      label: "Partner With Us",
      icon: <i className="mdi mdi-handshake-outline" />,
      condition:
        user?.form_name === "partner_with_us"
    },
    {
      value: 3,
      label: "Get Free Ride",
      icon: <i className="mdi mdi-taxi" />,
      condition:
        user?.form_name === "free_ride"
    },
    {
      value: 2,
      label: "Account",
      icon: <i className="ri-bank-line -mt-5" />,
      condition: user?.status === "1",
    },
    {
      value: 4,
      label: "Update Car Information",
      icon: <CarRepairIcon />,
      condition: user?.form_name === "drive_with_us" && driveWithUsData.length > 0,
    },
  ]
  console.log(value)
  const tabs = [
    {
      value: 1,
      label: "Drive With Us",
      icon: <i className="las la-car" />,
      condition:
        user?.form_name === "drive_with_us" &&
        driveWithUsData.some(
          (item) => isExpired(item.file_expiry) || item.file_status === 2
        ),
    },
    {
      value: 1,
      label: "Partner With Us",
      icon: <i className="mdi mdi-handshake-outline" />,
      condition:
        user?.form_name === "partner_with_us"
    },
    {
      value: 1,
      label: "Get Free Ride",
      icon: <i className="mdi mdi-taxi" />,
      condition:
        user?.form_name === "free_ride"
    },
    {
      value: 2,
      label: "Account",
      icon: <i className="ri-bank-line -mt-5" />,
      condition: user?.status === "1",
    },
    {
      value: 3,
      label: "Update Car Information",
      icon: <CarRepairIcon />,
      condition: user?.form_name === "drive_with_us" && driveWithUsData.length > 0,
    },
  ]


  return (
    <>
      {/* <Drawer open={anchorElNav} onClose={handleCloseNavMenu} anchor="left"  >
        <Box sx={{ width: { xs: "100%", md: 700 } }} className="profile-update" >
          <Container>
            <IconButton onClick={handleCloseNavMenu} >
              <Close />
            </IconButton>
            <Tabs
              value={value}
              orientation="vertical"
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="none"
              TabIndicatorProps={{
                children: <span className="MuiIndicator" />,
              }}
              sx={{

                position: "relative",
                '& .MuiTabs-flexContainer': {
                  position: 'relative',
                  zIndex: 1,
                },

                '& .MuiTab-root': {
                  textTransform: 'none',
                  minWidth: 100,
                  borderRadius: 2,
                  color: '#76a521',
                  px: 2,
                  py: 0,
                  fontWeight: 500,
                  minHeight: 45,
                  transition: 'all 0.3s ease',

                },
                '& .Mui-selected': {
                  backgroundColor: '#021B38',
                  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
                  color: '#76a521',


                },
              }}
            >
              {user?.form_name === "drive_with_us" && driveWithUsData.some((item) => isExpired(item.file_expiry) || item.file_status === 2) ?

                <Tab value="one" label={Label(user?.form_name)} />
                :
                user?.form_name === "free_ride" || user?.form_name === "partner_with_us" ?
                  <Tab value="one" label={Label(user?.form_name)} sx={{ display: { xs: "none", md: "block" } }} />
                  : null}
              {user?.status === "1" && (
                <Tab value="two" label="Payment" />
              )}
              {user?.form_name === "drive_with_us" && (
                <Tab value="three" label="Update Car Information" />
              )}
            </Tabs>
          </Container>
        </Box>
      </Drawer> */}
      <Box sx={{ background: { xs: "linear-gradient(180deg,rgba(151, 193, 31, 1) 26%, rgba(233, 255, 166, 1) 67%, rgba(255, 255, 255, 1) 94%)", md: "#FFF" }, height: { sm: value === 0 ? "97vh" : "100%", md: "100%" } }} >
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          PaperProps={{
            sx: {
              mt: 6.5,
              backgroundColor: '#021B38', // deep blue
              color: '#96c11e',
              borderRadius: 2,
              boxShadow: 3,
              minWidth: 200,
              '& .MuiMenuItem-root': {
                gap: 1,
                paddingY: 1,
                paddingX: 2,
                '&:hover': {
                  backgroundColor: '#021B48',
                },
              },
              '& .MuiSvgIcon-root': {
                color: '#96c11e',
              },
            },
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {mobileTabs.map((tab) => (
            tab.condition && (
              <MenuItem key={tab.value} onClick={() => { setValue(tab.value); handleCloseNavMenu() }}>
                {tab.icon}
                <Typography>{tab.label}</Typography>
              </MenuItem>
            )
          ))}


        </Menu>
        <Box className="p-2 p-md-5 " >
          <div className="cover-image pb-5  " style={{ borderRadius: 10 }} >
            <Header setValue={setValue} />
            <Container sx={{ pt: { xs: 1, md: 4 } }} >
              <Box sx={{ justifyContent: "end" }} className="d-none " >
                <Button onClick={() => navigate("/driver_forms/edit")} startIcon={<i className="ri-edit-box-line align-bottom" />} variant="contained" sx={{ px: 2, my: 2, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }} >Edit</Button>
              </Box>
            </Container>
          </div>
        </Box>
        <CssBaseline>
          <Box display={"flex"} justifyContent={"center"} mt={{ xs: -5, sm: -10, md: -15 }} >
            <Card sx={{ width: "90%", p: 4, borderRadius: 5, backgroundColor: "rgba(255,255,255,0.9)", backdropFilter: "saturate(200%) blur(30px)", display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between" }} variant="elevation" elevation={5} >
              <Box display={"flex"} alignItems={"center"} >
                <Box>
                  <Avatar sx={{ height: 60, width: 60 }} variant="rounded" alt="A" src={user?.profile_pic ? getDisplayUrl(user.profile_pic, IMAGES_URL) : ""} />
                </Box>
                <Box px={2} >
                  <Typography fontSize={"1.25rem"} fontWeight={600} fontFamily="sans-serif"  >{user?.first_name} {user?.last_name} </Typography>
                  {/* <Typography fontSize={"0.87rem"} color={"rgb(103, 116, 142)"} fontWeight={600} fontFamily="sans-serif"  >{user?.email} </Typography> */}
                </Box>

              </Box>
              <Box className="d-none d-md-block" >
                <CustomTabs
                  tabs={tabs}
                  currentValue={value}
                  onChange={(e, newVal) => setValue(newVal)}

                />

              </Box>
            </Card>
          </Box>
          <Container maxWidth="xl"  >
            <Grid container spacing={2} sx={{ px: { xs: 0, md: 4 }, pt: 0, mb: 5 }} >
              {value === 0 && (
                <Grid item xs={12} className="d-md-none d-block" >
                  <Typography variant="h5" mt={2} sx={{ fontSize: { xs: '2rem', sm: '2rem' } }} className="text-center" fontWeight={600}  >Get Better Transportation</Typography>
                  <Typography variant="subtitle1" fontSize={20} className="text-center py-2 "  >Manage your account from here</Typography>
                  <CustomButton onClick={() => setValue(1)} icon={<FontAwesomeIcon icon={faUser} style={{ color: 'white' }} />} label="Driver’s Profile" />
                  <CustomButton onClick={() => setValue(2)} icon={<FontAwesomeIcon icon={faCreditCard} style={{ color: 'white' }} />} label="Payment" />
                  {user?.form_name === "drive_with_us" && (
                    <CustomButton onClick={() => setValue(4)} icon={<DirectionsCarIcon style={{ color: 'white' }} />} label="Update Car Information" />
                  )}
                  {isDriveTabVisible && (
                    <CustomButton onClick={() => setValue(3)} length={expiredCount} icon={<PlagiarismIcon style={{ color: 'white' }} />} label="Expired Documents" />
                  )}
                </Grid>
              )}
              {value === 1 && (
                <Grid item xs={12} md={6} lg={4} mt={2}  className="d-md-none d-block" >
                  <ProfileCard value={value} setValue={setValue} />

                </Grid>
              )}
              <Grid item xs={12} md={5} lg={4} mt={5} className="d-md-block d-none" >
                <ProfileCard />

              </Grid>
              {window.innerWidth>768 && (
              <Grid item xs={12} md={7} lg={8} mt={5} className="d-none d-md-block"  >
                <SettingsCard value={value} setValue={setValue} driveWithUsData={driveWithUsData} partnerWithUsData={partnerWithUsData} freeRideData={freeRideData} />
              </Grid>
              )}
              {(value !== 0 && value !== 1 && window.innerWidth<768) && (
                <Grid item xs={12} md={7} lg={8} className="d-block d-md-none">
                  <SettingsCard value={value} setValue={setValue} driveWithUsData={driveWithUsData} partnerWithUsData={partnerWithUsData} freeRideData={freeRideData}   />
                </Grid>
              )}


            </Grid>
          </Container>
        </CssBaseline>
      </Box>
      <div style={{ position: "fixed", zIndex: 999, display: "flex", right: 15, bottom: 15, alignItems: "center", justifyContent: "center" }} >

        <p className={`whatsapp-title ${openLink ? "fade-in-right" : "fade-out-right"}`} >
          WhatsApp us
        </p>
        <a href="https://wa.link/nu9770" target="_blank" className="btn-whatsapp-pulse" onMouseOver={() => setOpenLink(true)} onMouseLeave={() => setOpenLink(false)} >
          <WhatsApp fontSize="19px" />

        </a>

      </div>

    </>
  );
}
